import { Button, ListItemButton, ListItemText } from "@mui/material";
import moment from "moment";
import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import checkAccess from "../../../../shared/checkAccess";
import CustomModal from "../../../../shared/CustomModal";
import CustomTable from "../../../../shared/CustomTable";
import notificationError from "../../../../shared/notificationError";
import notificationSuccess from "../../../../shared/notificationSuccess";
import { RootState } from "../../../../store";
import { approveOvertimeHead, approveOvertimeHr, deleteOvertime } from "../overtime.api";
import { setTimeGetData } from "../overtime.reducer";
import OvertimeApprovalHead from "./OvertimeApprovalHead";
import OvertimeApprovalHr from "./OvertimeApprovalHr";
import OvertimeEdit from "./OvertimeEdit";
import { OvertimeApprovelAnalyzeIcon } from "./OvertimeApprovelAnalyze";

export default function OvertimeAll() {

    const dispatch = useDispatch()

    const { timeGetData } = useSelector((state: RootState) => state.overtime)

    const [dataSelected, setDataSelected] = useState<any>({})
    const [modalEdit, setModalEdit] = useState(false)
    const [modalApprovalHead, setModalApprovalHead] = useState(false)
    const [modalApprovalHr, setModalApprovalHr] = useState(false)

    const handleCloseModalEdit = (isReload: boolean) => {
        setModalEdit(false)
        if (isReload) {
            dispatch(setTimeGetData(new Date().getTime()))
        }
    }

    const handleCloseModalApprovalHead = (isReload: boolean) => {
        setModalApprovalHead(false)
        if (isReload) {
            dispatch(setTimeGetData(new Date().getTime()))
        }
    }

    const handleCloseModalApprovalHr = (isReload: boolean) => {
        setModalApprovalHr(false)
        if (isReload) {
            dispatch(setTimeGetData(new Date().getTime()))
        }
    }

    const handleDelete = (id: string) => {
        Swal.fire({
            icon: "question",
            title: "Are you sure to delete this data?",
            showCancelButton: true
        })
            .then(response => {
                if (response.isConfirmed) {
                    dispatch<any>(deleteOvertime(id))
                        .unwrap()
                        .then((response: any) => {
                            if (response.status === 200) {
                                notificationSuccess("success delete overtime")
                                dispatch(setTimeGetData(new Date().getTime()))
                            }
                            else {
                                notificationError(response)
                            }
                        })
                }
            })
    }

    const handleApproveHeadMultiple = (dataIdSelected: any) => {
        if (dataIdSelected.length > 0) {
            dispatch<any>(approveOvertimeHead({
                ids: dataIdSelected
            }))
                .unwrap()
                .then((response: any) => {
                    if (response.status === 200) {
                        notificationSuccess("overtime successfully approved")
                        dispatch(setTimeGetData(new Date().getTime()))
                    }
                    else {
                        notificationError(response)
                    }
                })
        }
        else {
            Swal.fire({
                title: "Select at least one row",
                icon: "error"
            })
        }
    }

    const handleApproveHrMultiple = (dataIdSelected: any) => {
        if (dataIdSelected.length > 0) {
            dispatch<any>(approveOvertimeHr({
                ids: dataIdSelected
            }))
                .unwrap()
                .then((response: any) => {
                    if (response.status === 200) {
                        notificationSuccess("overtime successfully approved")
                        dispatch(setTimeGetData(new Date().getTime()))
                    }
                    else {
                        notificationError(response)
                    }
                })
        }
        else {
            Swal.fire({
                title: "Select at least one row",
                icon: "error"
            })
        }
    }

    return (
        <Fragment>
            <CustomModal
                open={modalEdit}
                onClose={handleCloseModalEdit}
                title="Edit Overtime"
                component={
                    <OvertimeEdit onClose={handleCloseModalEdit} data={dataSelected} />
                }
            />
            <CustomModal
                open={modalApprovalHead}
                onClose={handleCloseModalApprovalHead}
                title="Head Approval"
                component={
                    <OvertimeApprovalHead onClose={handleCloseModalApprovalHead} data={dataSelected} />
                }
            />
            <CustomModal
                open={modalApprovalHr}
                onClose={handleCloseModalApprovalHr}
                title="HR Approval"
                component={
                    <OvertimeApprovalHr onClose={handleCloseModalApprovalHr} data={dataSelected} />
                }
            />
            <CustomTable
                url={"/overtime"}
                filterDate={true}
                columns={[
                    {
                        name: "Employee",
                        key: "employee_name"
                    },
                    {
                        name: "Overtime Date",
                        key: "name",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <span>
                                        {props.data.name ? moment(props.data.name).format('DD-MM-YYYY') : '-'}
                                    </span>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Team",
                        key: "employee_team_names",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <p>
                                        {props.data.employee_team_names && props.data.employee_team_names.replaceAll(',', ', ')}
                                    </p>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Req Min",
                        key: "minutes",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <OvertimeApprovelAnalyzeIcon jobList={props.data.job_list ? JSON.parse(props.data.job_list) : []} requestMinute={props.data.minutes} />
                                </td>
                            )
                        }
                    },
                    {
                        name: "Notes",
                        key: "notes"
                    },
                    {
                        name: "Status",
                        key: "status_name"
                    },
                    {
                        name: "Approved Minutes",
                        key: "minutes_approval"
                    },
                    {
                        name: "Multiple",
                        key: "multiple"
                    },
                    {
                        name: "Rejection Notes",
                        key: "notes_approval"
                    },
                    {
                        name: "Job",
                        key: "job_list",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    {props.data.job_list
                                        ? <ul>
                                            {JSON.parse(props.data.job_list).map((job: any) => (
                                                <li>
                                                    {job.jobnumber_number_job} - ({job.quantity_pole})
                                                </li>
                                            ))}
                                        </ul>
                                        : '-'
                                    }
                                </td>
                            )
                        }
                    }
                ]}
                headerActions={(props: any) => (
                    <Fragment>
                        {checkAccess("APPROVAL_HEAD") &&
                            <Button
                                variant="contained"
                                onClick={() => handleApproveHeadMultiple(props.dataIdSelected)}
                            >
                                Approve Head
                            </Button>
                        }
                        {checkAccess("APPROVAL_HR") &&
                            <Button
                                variant="contained"
                                onClick={() => handleApproveHrMultiple(props.dataIdSelected)}
                            >
                                Approve HR
                            </Button>
                        }
                    </Fragment>
                )}
                rowActions={(props: any) => (
                    <Fragment>
                        {checkAccess("EDIT") &&
                            <ListItemButton onClick={() => { setDataSelected(props.data); setModalEdit(true) }}>
                                <ListItemText>Edit</ListItemText>
                            </ListItemButton>
                        }
                        {checkAccess("DELETE") &&
                            <ListItemButton onClick={() => handleDelete(props.data.id)}>
                                <ListItemText>Delete</ListItemText>
                            </ListItemButton>
                        }
                    </Fragment>
                )}
                rowActionsAdditional={(props: any) => {
                    return (
                        <Fragment>
                            {checkAccess("APPROVAL_HEAD") && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={e => {
                                        setDataSelected(props.data)
                                        setModalApprovalHead(true)
                                    }}>
                                    Head Approval
                                </Button>
                            )}
                            {checkAccess("APPROVAL_HR") && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={e => {
                                        setDataSelected(props.data)
                                        setModalApprovalHr(true)
                                    }}>
                                    HR Approval
                                </Button>
                            )}
                        </Fragment>
                    )
                }}
                timeGetData={timeGetData}
                selectRow={checkAccess("APPROVAL_HEAD") || checkAccess("APPROVAL_HR")}
            />
        </Fragment>
    )
}